/* global axios */
import ApiClient from './ApiClient';

// Card-4.10 (2026-04-29) — admin CRUD para sequências de atividades.
// Backend: app/controllers/api/v1/accounts/pipeline/activity_sequences_controller.rb
//
// Wrapper completo para PipelineSequenceDefinition: index/show/create/update/
// destroy + activate/deactivate/duplicate (member actions).
class PipelineSequenceDefinitionsAPI extends ApiClient {
  constructor() {
    // Note: o controller fica em namespace 'pipeline/activity_sequences'.
    super('pipeline/activity_sequences', { accountScoped: true });
  }

  collectionUrl(accountId = null) {
    return accountId === null || accountId === undefined
      ? this.url
      : this.urlForAccount(accountId);
  }

  list(
    {
      active = null,
      triggerType = null,
      q = null,
      page = 1,
      perPage = 25,
    } = {},
    accountId = null
  ) {
    const params = new URLSearchParams({ page, per_page: perPage });
    if (active !== null) params.append('active', active);
    if (triggerType) params.append('trigger_type', triggerType);
    // A blank term must not be sent: the backend treats it as "no filter"
    // anyway, and sending it would only make the URL noisier.
    if (q) params.append('q', q);
    return axios.get(`${this.collectionUrl(accountId)}?${params.toString()}`);
  }

  // `pipeline/sequence_analytics` is a sibling of this resource, not a nested
  // route, so it is derived from the collection URL rather than built by
  // ApiClient — which only knows how to address `pipeline/activity_sequences`.
  analyticsUrl(accountId = null) {
    return this.collectionUrl(accountId).replace(
      /\/activity_sequences$/,
      '/sequence_analytics'
    );
  }

  analytics(accountId = null) {
    return axios.get(this.analyticsUrl(accountId));
  }

  show(id, accountId = null) {
    return axios.get(`${this.collectionUrl(accountId)}/${id}`);
  }

  create(data, accountId = null) {
    return axios.post(
      this.collectionUrl(accountId),
      { pipeline_activity_sequence: data },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  update(id, data, accountId = null) {
    return axios.patch(
      `${this.collectionUrl(accountId)}/${id}`,
      { pipeline_activity_sequence: data },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  delete(id, accountId = null) {
    return axios.delete(`${this.collectionUrl(accountId)}/${id}`);
  }

  activate(id, accountId = null) {
    return axios.post(`${this.collectionUrl(accountId)}/${id}/activate`);
  }

  deactivate(id, accountId = null) {
    return axios.post(`${this.collectionUrl(accountId)}/${id}/deactivate`);
  }

  duplicate(id, newName = null, accountId = null) {
    const body = newName ? { name: newName } : {};
    return axios.post(`${this.collectionUrl(accountId)}/${id}/duplicate`, body);
  }

  accountCollectionUrl(accountId = null) {
    if (accountId === null || accountId === undefined || accountId === '') {
      return this.url;
    }
    return this.urlForAccount(accountId);
  }

  webhookCredentials(accountId = null) {
    return axios.get(
      `${this.accountCollectionUrl(accountId)}/webhook_credentials`
    );
  }

  rotateWebhookCredentials(credentialScope = 'all', accountId = null) {
    return axios.post(
      `${this.accountCollectionUrl(accountId)}/rotate_webhook_credentials`,
      {
        credential_scope: credentialScope,
      }
    );
  }
}

export default new PipelineSequenceDefinitionsAPI();
